import React, { useEffect } from "react";
import { useGetCorporateEngagementsCalendarQuery } from "../../../../redux/service/modules/dashboard";
import PaginatedDataTable from "../../../../components/table/PaginatedDataTable";
import { useSelector } from "react-redux";

const CAccessActivities = ({ appliedFilters, setRequiredFilters }) => {
    const dateRange = useSelector((state) => state.date);
    useEffect(() => {
        setRequiredFilters(["user"]);
    }, []);

    return (
        <PaginatedDataTable
            queryHook={useGetCorporateEngagementsCalendarQuery}
            initialDateRange={dateRange}
            appliedFilters={appliedFilters}
        />
    );
};

export default CAccessActivities;
